import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class ComeBackModal extends Widget {
	componentWillMount() {
		if (!window.is_basic) return;

		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;

		//under these conditions, we'd rather show the metered paywall
		//disabled b/c we're not running a metered paywall, we're running
		//a metered bumper
		// if (this.props.single && getCookie("tpm_article_views") > 9) return;

		//if this comeback modal has been dismissed
		if (getCookie("ComeBack")) return;

		//otherwise look up the profile
		const profileData = this.getProfileData();
		const self = this;

		if (typeof profileData.then === "function") {
			// promise
			profileData.then((resp) => {
				if (profile.membership_was) self.setState({ showComeBack: true });
			});
		} else {
			//not a promise
			if (profile.membership_was) self.setState({ showComeBack: true });
		}
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		return getProfile();
	}

	toggle() {
		this.setState({ shrink: !this.state.shrink });
		setCookie("ComeBack", "1", 1); // cookie expires in 1 day
	}

	render() {
		if (!this.state.showComeBack) return;
		if (!this.state.shrink) {
			return (
				<div class="ComeBack">
					<div class="ComeBack__Inner tall">
						<div class="ComeBack__Toggle" onClick={this.toggle.bind(this)}>
							<Icon name="chevron-down" style="light" />
						</div>
						<div class="ComeBack__Main">
							<div class="ComeBack__Deal">
								SPECIAL DEAL FOR PAST TPM MEMBERS
							</div>
							<div class="ComeBack__Offer">GET 40% OFF PRIME</div>
							<a
								href={`${document.location.origin}/memberships/prime-annual?promo=40off&utm_source=on_site&utm_medium=return-modal&utm_campaign=memberships`}
								class="ComeBack__Price"
							>
								Rejoin and get 40% off an annual membership
							</a>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div class="ComeBack">
					<div class="ComeBack__Inner short">
						<div class="ComeBack__Toggle" onClick={this.toggle.bind(this)}>
							<Icon name="chevron-up" style="light" />
						</div>
						<div class="ComeBack__Main">
							<a
								href={`${document.location.origin}/memberships/prime-annual?promo=40off&utm_source=on_site&utm_medium=return-modal&utm_campaign=memberships`}
								class="ComeBack__Price"
							>
								Rejoin and get 40% off an annual membership
							</a>
						</div>
					</div>
				</div>
			);
		}
	}
}
